import {EDIT_LOG, GET_EDIT_LOG, LogEdit } from "../../../Model/Log"

const initState: LogEdit = {
    ResultDtoEdit: null,
    LogEdit: null,
}
//const dispatch = useDispatch();


export const LogEditReducer = (state = initState, action: { type: string, payload: LogEdit }) => {
    switch (action.type) {
        case EDIT_LOG:
            {
                return { ...state, ResultDtoEdit: action.payload.ResultDtoEdit }
            }
        case GET_EDIT_LOG:
            return { ...state, LogDtoEdit: action.payload.LogEdit }
        default:
            return state;
    }
}